import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  loadCookieConsentScript(userLang: string): void {
    document.documentElement.setAttribute('lang', userLang);
    const domainScript = environment.oneTrustCookie.domainScript;
    const script = document.createElement('script');
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.setAttribute('data-domain-script', domainScript);
    script.setAttribute('data-document-language', 'true');
    document.head.appendChild(script);
  }
}
